import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import { createSelector } from 'reselect';
var entitySelector = function entitySelector(store) {
  var _store$api;
  return store === null || store === void 0 ? void 0 : (_store$api = store.api) === null || _store$api === void 0 ? void 0 : _store$api.entities;
};

// UIE-45 -- unused?
export var verifiedDocumentSelector = createSelector(entitySelector, function (entities) {
  return entities.verified_document;
});
var verifiedDocumentsForRequirement = function verifiedDocumentsForRequirement(requirementId) {
  return createSelector(entitySelector, function (entities) {
    if (!entities.verified_document) {
      return null;
    }
    return Object.values(entities.verified_document).filter(function (document) {
      var _document$attributes;
      if (!Array.isArray(document === null || document === void 0 ? void 0 : (_document$attributes = document.attributes) === null || _document$attributes === void 0 ? void 0 : _document$attributes.relatedEntities)) {
        return false;
      }
      return Boolean(document.attributes.relatedEntities.find(function (relatedEntity) {
        return relatedEntity.type === 'application_requirement' && relatedEntity.id === requirementId;
      }));
    });
  });
};
export var verifiedDocumentForRequirement = function verifiedDocumentForRequirement(requirementId) {
  return createSelector(verifiedDocumentsForRequirement(requirementId), function (documents) {
    if (!documents || !Array.isArray(documents) || documents.length <= 0) return null;
    return documents.sort(function (a, b) {
      return a.attributes.createdAt < b.attributes.createdAt ? 1 : -1;
    })[0];
  });
};